import { useTranslation } from "@equiem/web-ng-lib";
import React from "react";
import { SubscriptionBillingCycle } from "../../../generated/gateway-client";
import { PriceFormat } from "../../PriceFormat";
import { SearchNode } from "./SearchEdge";
import { SearchResult } from "./SearchResult";
import { FaStore } from "react-icons/fa";

interface Props {
  product: SearchNode<"SubscriptionProductContentEdge">;
}

export const SubscriptionProductSearchResult: React.FC<Props> = ({
  product,
}) => {
  const { t } = useTranslation();

  const cycle =
    product.billingCycle === SubscriptionBillingCycle.Weekly
      ? t("main.week")
      : t("main.month");

  return (
    <SearchResult
      href="/store/product/[uuid]"
      as={`/store/product/${product.uuid}`}
      title={product.name}
      body={product.excerpt}
      imageUrl={product.image ?? undefined}
      footer={
        <div className="mt-auto">
          <div className="vendor-name pb-2 d-flex align-items-center">
            <FaStore /> <span className="ml-2">{product.vendor.name}</span>
          </div>
          <PriceFormat price={product.unitPrice} freeTxt={t("main.free")} />/{cycle}
        </div>
      }
    />
  );
};
